export const defaultDimensions = {
  childPage: {
    percentage: 20,
    maxWidth: 300,
    minWidth: 110,
    maxCharacters: 60,
    minCharacters: 7,
  },
  parentPage: {
    width: 120,
  },
  currentPage: {
    percentage: 30,
    maxWidth: 700,
    minWidth: 200,
    maxCharacters: 100,
    minCharacters: 60,
    paragraph: {
      maxCharacters: 250,
      minCharacters: 60,
    },
    button: {
      percentage: 15,
      maxWidth: 40,
      minWidth: 25,
    },
  },
};
